import { sparkPoints } from './geometry';

export interface SparklineProps {
  /** Per-period values. */
  days: readonly number[];
  /** Invert so a falling metric draws as a rising (good) line. */
  inverted?: boolean;
  /** Accessible summary; the KPI value/delta carry the real information. */
  label: string;
}

/**
 * §5.1 KPI sparkline — decorative accent stroke over an 80×22 non-uniform
 * viewBox. The trend is never the sole carrier (the tile states value + delta in
 * text), so this only needs a short `aria-label`.
 */
export function Sparkline({ days, inverted = false, label }: SparklineProps): React.JSX.Element {
  return (
    <svg
      width="100%"
      height="22"
      viewBox="0 0 80 22"
      preserveAspectRatio="none"
      fill="none"
      role="img"
      aria-label={label}
    >
      <polyline points={sparkPoints(days, inverted)} stroke="var(--a-bd)" strokeWidth="1.5" />
    </svg>
  );
}
